export default [
  {
    id: "Round1",
    passes: {
      working_single: 0,
      media_single: 0,
      paddock_guest_wristband: 0,
      vendor_guest_wristband: 0,
      broadcast_guest_wristband: 0,
      model: 0,
      season: 0,
      season_media: 0,
      hotpit_guest: 0,
    },
    name: "Daytona International Speedway",
    location: "Daytona Beach, FL",
    trackName: "daytona",
    schedule: "March 5-7",
    start: "2026-03-05",
    end: "2026-03-07",
  },
  {
    id: "Round2",
    passes: {
      working_single: 0,
      media_single: 0,
      paddock_guest_wristband: 0,
      vendor_guest_wristband: 0,
      broadcast_guest_wristband: 0,
      model: 0,
      season: 0,
      season_media: 0,
      hotpit_guest: 0,
    },
    name: "Michelin Raceway Road Atlanta",
    location: "Braselton, Georgia",
    trackName: "roadatlanta",
    schedule: "April 17-19",
    start: "2026-04-17",
    end: "2026-04-19",
  },
  {
    id: "Round3",
    passes: {
      working_single: 0,
      media_single: 0,
      paddock_guest_wristband: 0,
      vendor_guest_wristband: 0,
      broadcast_guest_wristband: 0,
      model: 0,
      season: 0,
      season_media: 0,
      hotpit_guest: 0,
    },
    name: "Barber Motorsports Park",
    location: "Birmingham, Alabama",
    trackName: "barber",
    schedule: "May 15-17",
    start: "2026-05-15",
    end: "2026-05-17",
  },
  {
    id: "Round4",
    passes: {
      working_single: 0,
      media_single: 0,
      paddock_guest_wristband: 0,
      vendor_guest_wristband: 0,
      broadcast_guest_wristband: 0,
      model: 0,
      season: 0,
      season_media: 0,
      hotpit_guest: 0,
    },
    name: "Road America",
    location: "Elkhart Lake, Wisconsin",
    trackName: "roadamerica",
    schedule: "May 29-31",
    start: "2026-05-29",
    end: "2026-05-31",
  },
  {
    id: "Round5",
    passes: {
      working_single: 0,
      media_single: 0,
      paddock_guest_wristband: 0,
      vendor_guest_wristband: 0,
      broadcast_guest_wristband: 0,
      model: 0,
      season: 0,
      season_media: 0,
      hotpit_guest: 0,
    },
    name: "Ridge Motorsports Park",
    location: "Shelton, Washington",
    trackName: "theridge",
    schedule: "June 26-28",
    start: "2026-06-26",
    end: "2026-06-28",
  },
  {
    id: "Round6",
    passes: {
      working_single: 0,
      media_single: 0,
      paddock_guest_wristband: 0,
      vendor_guest_wristband: 0,
      broadcast_guest_wristband: 0,
      model: 0,
      season: 0,
      season_media: 0,
      hotpit_guest: 0,
    },
    name: "WeatherTech Raceway Laguna Seca",
    location: "Monterey, California",
    trackName: "mazda",
    schedule: "July 10-12",
    start: "2026-07-10",
    end: "2026-07-12",
  },
  {
    id: "Round7",
    passes: {
      working_single: 0,
      media_single: 0,
      paddock_guest_wristband: 0,
      vendor_guest_wristband: 0,
      broadcast_guest_wristband: 0,
      model: 0,
      season: 0,
      season_media: 0,
      hotpit_guest: 0,
    },
    name: "Mid-Ohio Sports Car Course",
    location: "Lexington, Ohio",
    trackName: "midohio",
    schedule: "July 31 - August 2",
    start: "2026-07-31",
    end: "2026-08-02",
  },
  {
    id: "Round8",
    passes: {
      working_single: 0,
      media_single: 0,
      paddock_guest_wristband: 0,
      vendor_guest_wristband: 0,
      broadcast_guest_wristband: 0,
      model: 0,
      season: 0,
      season_media: 0,
      hotpit_guest: 0,
    },
    name: "Virginia International Raceway",
    location: "Alton, Virginia",
    trackName: "vir",
    schedule: "August 14-16",
    start: "2026-08-14",
    end: "2026-08-16",
  },
  {
    id: "Round9",
    passes: {
      working_single: 0,
      media_single: 0,
      paddock_guest_wristband: 0,
      vendor_guest_wristband: 0,
      broadcast_guest_wristband: 0,
      model: 0,
      season: 0,
      season_media: 0,
      hotpit_guest: 0,
    },
    name: "Circuit of The Americas",
    location: "Austin, Texas",
    trackName: "cota",
    schedule: "September 11-13",
    start: "2026-09-11",
    end: "2026-09-13",
  },
  {
    id: "Round10",
    passes: {
      working_single: 0,
      media_single: 0,
      paddock_guest_wristband: 0,
      vendor_guest_wristband: 0,
      broadcast_guest_wristband: 0,
      model: 0,
      season: 0,
      season_media: 0,
      hotpit_guest: 0,
    },
    name: "New Jersey Motorsports Park",
    location: "Millville, New Jersey",
    trackName: "newjersey",
    schedule: "September 25-27",
    start: "2026-09-25",
    end: "2026-09-27",
  },
  {
    id: "manually-assigned-credentials",
    passes: {
      working_single: 0,
      media_single: 0,
      paddock_guest_wristband: 0,
      vendor_guest_wristband: 0,
      broadcast_guest_wristband: 0,
      model: 0,
      season: 0,
      season_media: 0,
      hotpit_guest: 0,
    },
    name: "Manually Assigned Credentials",
    location: "",
    trackName: "",
    schedule: "",
    start: "",
    end: "",
  },
];



// WEBPACK FOOTER //
// ./src/constants/rounds.js